module.exports = __webpack_public_path__ + "static/media/emirates.0f9f413b.png";